/**
 * 主题色 store 模块
 * 功能：从 localStorage 读默认色 #409eff，提供 save_color mutation
 */
const themePicker = {
    state: {
        color: localStorage.getItem("color")?localStorage.getItem("color"):"#409eff",//选中颜色
    },
    getters: {
        color: state => state.color,
    },
    mutations: {
        // 添加tabs
        save_color(state, data) {
            state.color=data;
        },
    },
    actions: {

    }
};

export default themePicker
